'use strict';

module.exports = require('./core/');


//////////////////
// WEBPACK FOOTER
// ./~/modal-video/lib/index.js
// module id = 22
// module chunks = 0